
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("5XrRK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "EmptySkeleton", () => $1f7e6cc6bb050ade$export$fb85bbdbfb3e6869);
$parcel$export(module.exports, "GinRedirect", () => $1f7e6cc6bb050ade$export$3b4f172f4310bbc);
$parcel$export(module.exports, "GinRedirectEntryPoint", () => $1f7e6cc6bb050ade$export$259dd4583d348d86);
$parcel$export(module.exports, "default", () => $1f7e6cc6bb050ade$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1kQCU = parcelRequire("1kQCU");

var $VILOn = parcelRequire("VILOn");

var $7SHTM = parcelRequire("7SHTM");

var $1gXMV = parcelRequire("1gXMV");

var $cZpsT = parcelRequire("cZpsT");

var $l8ruj = parcelRequire("l8ruj");

var $7CMCs = parcelRequire("7CMCs");

var $frBVt = parcelRequire("frBVt");

var $383Br = parcelRequire("383Br");

var $cSD7y = parcelRequire("cSD7y");
const $1f7e6cc6bb050ade$export$fb85bbdbfb3e6869 = ()=>null;
const $1f7e6cc6bb050ade$var$GlobalIssueNavigatorEntryPointContainer = /*#__PURE__*/ (0, $5uXOq.memo)(({ entryPointReference: entryPointReference, nativeIssueTableEntryPoint: nativeIssueTableEntryPoint })=>{
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            preloadedEntryPoints: {
                nativeIssueTableEntryPoint: nativeIssueTableEntryPoint
            }
        }), [
        nativeIssueTableEntryPoint
    ]);
    const MaybeErrorBoundary = (0, $cSD7y.componentWithFG)('improve_nin_slo_events', (0, $383Br.NinErrorBoundary), (0, $7CMCs.JSErrorBoundary));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "jira-router-gin-redirect-entrypoint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MaybeErrorBoundary, {
        id: "jira-router-gin-redirect-entrypoint",
        packageName: "jiraRouterIssueNavigatorEntries"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointReferencePlaceholder), {
        name: "gin-redirect-entrypoint",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f7e6cc6bb050ade$export$fb85bbdbfb3e6869, null),
        entryPointReference: entryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: entryPointReference,
        // EntryPointContainer can't infer the type of props from entryPointReference correctly
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: entryPointProps
    }))));
});
const $1f7e6cc6bb050ade$export$3b4f172f4310bbc = ({ preloadedEntryPoints: preloadedEntryPoints })=>{
    const [isNinGlobalScopeEnrolmentEnabled, resourceData] = (0, $1kQCU.useGlobalScopeEnrolmentEnable)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    // Regardless of the existing localStorageData value, we update the localStorage value once we get resourceData so
    // that future renders are fast and accurate.
    (0, $5uXOq.useEffect)(()=>{
        if (resourceData !== null && resourceData !== undefined) (0, $VILOn.setIsGlobalScopeEnrolmentEnabledInLocalStorage)(resourceData);
    }, [
        resourceData
    ]);
    // If NIN in global scope is not enabled then we redirect to legacy GIN by performing a reload
    (0, $5uXOq.useEffect)(()=>{
        if (isNinGlobalScopeEnrolmentEnabled === false) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    }, [
        isNinGlobalScopeEnrolmentEnabled
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isNinGlobalScopeEnrolmentEnabled) {
            // If we are in global scope nin then reset/enable the forced opt out flag for GIN if we haven't done it already
            const globalGINFlagDisabled = (0, $VILOn.getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage)();
            if (globalGINFlagDisabled !== false) {
                !isAnonymous && (0, $7SHTM.resetGlobalScopeForcedOptOutGinFlag)();
                (0, $VILOn.setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage)();
            }
        }
    }, [
        isAnonymous,
        isNinGlobalScopeEnrolmentEnabled
    ]);
    const entryPointReference = preloadedEntryPoints.globalIssueNavigatorEntryPoint;
    const nativeIssueTableEntryPoint = preloadedEntryPoints.nativeIssueTableEntryPoint;
    // If NIN in global scope is enabled then we render it. If NIN in global scope is not enabled, or we're blocked
    // waiting on the resource to load then we render GlobalIssueNavigatorSkeleton.
    return isNinGlobalScopeEnrolmentEnabled === true && entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f7e6cc6bb050ade$var$GlobalIssueNavigatorEntryPointContainer, {
        entryPointReference: entryPointReference,
        nativeIssueTableEntryPoint: nativeIssueTableEntryPoint
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1gXMV.GlobalIssueNavigatorSkeleton), null);
};
const $1f7e6cc6bb050ade$export$259dd4583d348d86 = ({ entryPoints: entryPoints })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f7e6cc6bb050ade$export$3b4f172f4310bbc, {
        preloadedEntryPoints: entryPoints
    });
var $1f7e6cc6bb050ade$export$2e2bcd8739ae039 = $1f7e6cc6bb050ade$export$259dd4583d348d86;

});
parcelRegister("383Br", function(module, exports) {

$parcel$export(module.exports, "NinErrorBoundary", () => $21969641ec14a234$export$b63c3d14be9f8b13);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $93jKl = parcelRequire("93jKl");

var $dAfqg = parcelRequire("dAfqg");

var $efvDm = parcelRequire("efvDm");

var $kaHBi = parcelRequire("kaHBi");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $6UAdF = parcelRequire("6UAdF");
const $21969641ec14a234$var$ANALYTICS_SOURCE = 'issue-navigator';
const $21969641ec14a234$export$b63c3d14be9f8b13 = ({ children: children, id: id, packageName: packageName })=>{
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const onExperienceStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $6UAdF.EXPERIENCE_NAME),
        experienceId: undefined,
        analyticsSource: $21969641ec14a234$var$ANALYTICS_SOURCE
    });
    const appEditions = (0, $k9JTq.useAppEditions)();
    const application = project?.projectType ? (0, $efvDm.getApplicationForProject)(project.projectType) : (0, $efvDm.JIRA_SOFTWARE);
    const edition = (0, $ldyPw.getEdition)(application, appEditions);
    const analyticsAttributes = {
        application: application,
        edition: edition
    };
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $6UAdF.EXPERIENCE_NAME),
        attributes: analyticsAttributes
    });
    const onError = (0, $5uXOq.useCallback)((location, error)=>{
        onExperienceStart();
        onExperienceFail(location, error);
    }, [
        onExperienceFail,
        onExperienceStart
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        onError: onError,
        sendToPrivacyUnsafeSplunk: true
    }, children);
};

});



//# sourceMappingURL=async-global-issue-navigator-gin-redirect-entrypoint.bc82ce89.js.map
